@use '@lib/assets/styles/main.scss' as *;

.pagination {
  background-color: $gray0;
}

.documentsGrid {
  & > * + * {
    margin-top: 16px;
  }
}

.message {
  margin-bottom: 8px;
  margin-top: -8px;
}
